// Schedule baselines (back/routes/scheduleBaselines.js): what the plan
// said when someone agreed to it, and what has moved since.
import { url, tokenRef } from "api";

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem(tokenRef)}`,
});
const handle = async (r) => {
  const d = await r.json();
  if (!r.ok) { const e = new Error(d.err || "Request failed"); e.status = r.status; throw e; }
  return d;
};

export const listBaselines = async (projectId) =>
  handle(await fetch(`${url}/projects/${projectId}/baselines`, { headers: headers() }));

export const takeBaseline = async (projectId, body) =>
  handle(await fetch(`${url}/projects/${projectId}/baselines`, { method: "POST", headers: headers(), body: JSON.stringify(body) }));

export const activateBaseline = async (projectId, id) =>
  handle(await fetch(`${url}/projects/${projectId}/baselines/${id}/activate`, { method: "POST", headers: headers() }));

// `id` may be "active".
export const getVariance = async (projectId, id = "active") =>
  handle(await fetch(`${url}/projects/${projectId}/baselines/${id}/variance`, { headers: headers() }));

export const deleteBaseline = async (projectId, id) =>
  handle(await fetch(`${url}/projects/${projectId}/baselines/${id}`, { method: "DELETE", headers: headers() }));

// "7 days late" / "2 days early" / "on the baseline" - the same words in
// every place a slip is shown.
export const slipLabel = (days) => {
  if (days === null || days === undefined) return "—";
  if (days === 0) return "on the baseline";
  const n = Math.abs(days);
  return `${n} day${n === 1 ? "" : "s"} ${days > 0 ? "late" : "early"}`;
};
